package com.starparty.app.astro0.js

import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Paint
import com.starparty.app.geometry.SP_Rectangle

class SP_JSPaint: SP_Paint() {

   // var p: Paint = Paint()

    override fun setColour(c: SP_Colour) {
        currentColour = c
    }

    override fun getTextBounds(string: String): SP_Rectangle // todo: implement
    {
       // val rect = Rect(0,0,0,0)

      //  p.getTextBounds(string, 0, string.length - 1, rect)

        return SP_Rectangle(0.0,0.0,0.0,0.0)
       //     left.toDouble(), rect.top.toDouble(),
       //     rect.width().toDouble(), rect.height().toDouble())
    }

    init {
     //   p.style = Paint.Style.FILL
     //   p.textSize = defTextSize
     //   p.isAntiAlias = true
     //   p.color = Color.RED
    }
}